

import React, { useState, useEffect, useRef } from "react";
import Management2 from "./Management2";
import { useNavigate } from "react-router-dom";
import Menudatas from "./Menudatas";
import './categories.css';
import "./Style.css";
import './Management2.css';
import ItemUpdates from "./ItemUpdates";
import ItemDiscounts from "./ItemDiscounts"; // Import the new component

function Categories({ onActiveTabChange = () => {} }) {
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("first");
  const [subscriptionPlan, setSubscriptionPlan] = useState("basic"); // Default to basic
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [image, setImage] = useState(null);
  const [text, setText] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [activeTabName, setActiveTabName] = useState("Add Items");
  const [editSubItem, setEditSubItem] = React.useState({
    dishId: '',
    subName: '',
    price: '',
    stockQuantity: '',
    image: '',
    parentIndex: null,
    subIndex: null,
  });
  const tabNames = {
    "first": "Add Items",
    "second": "Item Quantity",
    "third": "Item Discount",
    "fourth": "Menu Data" // If you still have this tab
  };

  // Function to handle tab change
  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    // Notify parent component about the active tab change
    if (onActiveTabChange) {
      onActiveTabChange(tabNames[tabKey] || "Menu Management");
    }
  };
  // Notify parent about initial tab on mount
  useEffect(() => {
    if (onActiveTabChange) {
      onActiveTabChange(tabNames[activeTab] || "Add Items");
    }
  }, []); // Run only once on mount

  // Get subscription plan from localStorage on component mount
  useEffect(() => {
    const getSubscriptionPlan = () => {
      try {
        const planData = localStorage.getItem("planTypes");
        if (planData) {
          let plans = JSON.parse(planData);

          // Ensure it's always an array
          if (!Array.isArray(plans)) {
            plans = [plans];
          }

          // Normalize to lowercase for comparison
          const normalizedPlans = plans.map(p => p.toLowerCase());

          // Check for available plans (basic, standard, premium)
          let selectedPlan = "basic"; // default
          if (normalizedPlans.includes("premium")) selectedPlan = "premium";
          else if (normalizedPlans.includes("standard")) selectedPlan = "standard";
          else if (normalizedPlans.includes("basic")) selectedPlan = "basic";

          //console.log("📦 Subscription plan detected:", selectedPlan);
          setSubscriptionPlan(selectedPlan);
        } else {
          console.warn("⚠️ No subscription plan found in localStorage");
          setSubscriptionPlan("basic");
        }
      } catch (error) {
        console.error("Error parsing subscription plan:", error);
        setSubscriptionPlan("basic");
      }
    };

    getSubscriptionPlan();
  }, []);

  const applyFilter = (allData, vegOnly) => {
    if (vegOnly === null) {
      setFilteredData(allData);
      return;
    }

    const filtered = allData.map(category => {
      const filteredSubcategories = category.subcategories.filter(
        sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
      );

      return {
        ...category,
        subcategories: filteredSubcategories
      };
    }).filter(cat => cat.subcategories.length > 0);

    setFilteredData(filtered);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = () => {
    if (!text || !image) {
      alert("Please fill in all fields.");
      return;
    }
    //console.log("Saved category:", text, image);
    setShowPopup(false);
    setImage(null);
    setText("");
  };

  const styles = {
    overlay: {
      position: "fixed",
      top: 0, left: 0,
      width: "100%", height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex", justifyContent: "center", alignItems: "center",
      zIndex: 1000,
    },
    popup: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "10px",
      width: "300px",
      position: "relative",
    },
    input: {
      width: "90%",
      padding: "10px",
      marginTop: "10px",
      fontSize: "16px",
    },
    buttons: {
      textAlign: "center",
      marginTop: "15px",
    },
    saveBtn: {
      padding: "10px 20px",
      backgroundColor: "#4CAF50",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
    }
  };

  // Determine which buttons to show based on subscription plan
  const showItemsUpdateButton = subscriptionPlan === "standard" || subscriptionPlan === "premium";
  const showItemDiscountsButton = subscriptionPlan === "standard" || subscriptionPlan === "premium"; // Only for premium plan

  return (
    <div>
      {/* Tab Headers */}
      <div className="tavheders"
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "nowrap",
          alignItems: "center",
          flexWrap: "wrap",
          marginBottom: window.innerWidth < 768 ? "0rem" : "1rem",
          gap: "1rem",
        }}
      >
        {/* Left Buttons: Menu, Item Details, Items Update (only for standard/premium), Item Discounts (only for premium) */}
        <div
          className="leftbuttonmenu"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            marginTop: "60px",
            marginBottom: window.innerWidth < 768 ? "0px" : "30px",
            flexDirection: window.innerWidth <= 768 ? "row" : "row",
            flexWrap: "wrap", // Add this to allow buttons to wrap if needed
          }}
        >
          <div
            className="menubutton"
            style={{
              padding: "10px 15px", // Increased from 10px 20px to 10px 15px
              border: "none",
              backgroundColor: "#d9d9d9",
              color: "#000",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "all 0.3s",
              fontWeight: "bold",
              width: "auto",
              textAlign: "center",
              fontSize: window.innerWidth < 1100 ? "12px" : window.innerWidth < 1200 ? "13px" : "15px",
              whiteSpace: "nowrap", // ADD THIS - prevents text wrapping
              flexShrink: 0, // ADD THIS - prevents button from shrinking
            }}
            onClick={() => navigate("/menuiteams")}
          >
            Menu
          </div>

          <div
            className="itemdetailsbutton"
            style={{
              padding: "10px 15px", // Increased from 10px 8px to 10px 15px
              border: "none",
              backgroundColor: activeTab === "first" ? "#b15cd6" : "#d9d9d9",
              color: activeTab === "first" ? "white" : "#000",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "all 0.3s",
              fontWeight: "bold",
              boxShadow: activeTab === "first" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
              width: "auto",
              textAlign: "center",
              fontSize: window.innerWidth < 1100 ? "12px" : window.innerWidth < 1200 ? "13px" : "15px",
              whiteSpace: "nowrap", // ADD THIS
              flexShrink: 0, // ADD THIS
            }}
            onClick={() => handleTabChange("first")}
          >
            Add Items
          </div>

          {/* Items Update Button - Only show for standard and premium plans */}
          {showItemsUpdateButton && (
            <div
              className="itemsupdatebutton"
              style={{
                padding: "10px 15px", // Increased from 10px 8px to 10px 15px
                border: "none",
                backgroundColor: activeTab === "second" ? "#b15cd6" : "#d9d9d9",
                color: activeTab === "second" ? "white" : "#000",
                borderRadius: "5px",
                cursor: "pointer",
                transition: "all 0.3s",
                fontWeight: "bold",
                boxShadow: activeTab === "second" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
                width: "auto",
                textAlign: "center",
                fontSize: window.innerWidth < 1100 ? "12px" : window.innerWidth < 1200 ? "13px" : "15px",
                whiteSpace: "nowrap", // ADD THIS
                flexShrink: 0, // ADD THIS
              }}
              onClick={() => handleTabChange("second")}
            >
              Item Quantity
            </div>
          )}

          {/* Item Discounts Button - Only show for premium plan */}
          {showItemDiscountsButton && (
            <div
              className="itemdiscountsbutton"
              style={{
                padding: "10px 15px", // Increased from 10px 8px to 10px 15px
                border: "none",
                backgroundColor: activeTab === "third" ? "#b15cd6" : "#d9d9d9",
                color: activeTab === "third" ? "white" : "#000",
                borderRadius: "5px",
                cursor: "pointer",
                transition: "all 0.3s",
                fontWeight: "bold",
                boxShadow: activeTab === "third" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
                width: "auto",
                textAlign: "center",
                fontSize: window.innerWidth < 1100 ? "12px" : window.innerWidth < 1200 ? "13px" : "15px",
                whiteSpace: "nowrap", // ADD THIS
                flexShrink: 0, // ADD THIS
              }}
              onClick={() => handleTabChange("third")}
            >
              Item Discount
            </div>
          )}
        </div>

      </div>

      {/* Tab Content */}
      <div>
        {activeTab === "first" && <Management2 plan={subscriptionPlan} />}
        {activeTab === "second" && showItemsUpdateButton && (
          <ItemUpdates />
        )}
        {activeTab === "third" && showItemDiscountsButton && (
          <ItemDiscounts />
        )}
        {/* Note: The old "third" tab (Menudatas) would now be "fourth" if you still need it */}
        {activeTab === "fourth" && <Menudatas />}
      </div>
    </div>
  );
}

export default Categories;